import React from 'react';
import { Phone, Mail, MessageCircle, ClipboardList, MessageSquare } from 'lucide-react';

export function ChannelIcon({ channel, showLabel = false }) {
  const channelConfig = {
    whatsapp: {
      icon: Phone,
      label: 'WhatsApp',
      className: 'text-green-600',
    },
    email: {
      icon: Mail,
      label: 'Email',
      className: 'text-blue-600',
    },
    web: {
      icon: MessageCircle,
      label: 'Web',
      className: 'text-purple-600',
    },
    sms: {
      icon: MessageSquare,
      label: 'SMS',
      className: 'text-gray-600',
    },
    meeting_note: {
      icon: ClipboardList,
      label: 'Meeting Note',
      className: 'text-[#547a84]',
    },
  };

  const config = channelConfig[channel] || channelConfig.web;
  const Icon = config.icon;

  if (showLabel) {
    return (
      <div className="flex items-center gap-2">
        <Icon className={`h-4 w-4 ${config.className}`} />
        <span className="text-sm font-medium">{config.label}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <Icon className={`h-4 w-4 ${config.className}`} />
      <span className="text-sm capitalize">{channel}</span>
    </div>
  );
}